// Central client for fetching CMS content with seamless default fallbacks

export const DEFAULT_SITE_SETTINGS = {
  name: 'EK Biler v/Steen Svensson Ek',
  address: 'Mejerivej 12, 7250 Hejnsvig',
  phone: '22 18 73 30',
  phone_raw: '22187330',
  email: 'steen@ekbiler.dk',
  cvr: '28566956',
  booking_url: 'https://service.dinbilpartner.dk/book-tid',
  facebook_url: 'https://www.facebook.com/ekbiler.dk/',
  maps_url: 'https://www.google.com/maps/search/?api=1&query=EK+Biler+Mejerivej+12+7250+Hejnsvig',
  indicata_url: 'https://lg.indicata.com/#/?dealerId=156f3c15-a501-4045-bf19-5598ec416fd9',
  dinbilpartner_url: 'https://dinbilpartner.dk/',
  hourly_rate: '595 kr. ekskl. moms',
}

export const OPENING_HOURS = {
  salg: [
    { days: 'Mandag – Torsdag', hours: '9:00 – 17:30' },
    { days: 'Fredag', hours: '9:00 – 15:00' },
    { days: 'Lørdag', hours: 'Lukket' },
    { days: 'Søndag', hours: 'Åben efter aftale' },
  ],
  vaerksted: [
    { days: 'Mandag – Torsdag', hours: '7:30 – 16:00' },
    { days: 'Fredag', hours: '7:30 – 13:30' },
    { days: 'Lørdag – Søndag', hours: 'Lukket' },
  ],
  administration: [
    { days: 'Mandag – Torsdag', hours: '9:00 – 17:30' },
    { days: 'Fredag', hours: '9:00 – 15:00' },
    { days: 'Lørdag – Søndag', hours: 'Lukket' },
  ],
}

export async function fetchSiteSettings() {
  try {
    const res = await fetch('/_api/public/content/site_settings')
    if (res.ok) {
      const items = await res.json()
      if (Array.isArray(items) && items.length > 0) {
        const item = items[0].data || items[0]
        return {
          ...DEFAULT_SITE_SETTINGS,
          ...item,
          phone_raw: (item.phone || DEFAULT_SITE_SETTINGS.phone).replace(/\s+/g, ''),
        }
      }
    }
  } catch (err) {
    console.warn('Could not fetch site_settings from CMS:', err)
  }
  return DEFAULT_SITE_SETTINGS
}

export async function fetchNavigationItems() {
  try {
    const res = await fetch('/_api/public/content/navigation_items')
    if (res.ok) {
      const items = await res.json()
      if (Array.isArray(items) && items.length > 0) {
        return items
          .map((i) => i.data || i)
          .sort((a, b) => (Number(a.sort_order) || 0) - (Number(b.sort_order) || 0))
      }
    }
  } catch (err) {
    console.warn('Could not fetch navigation_items from CMS:', err)
  }
  return [
    { label: 'Brugte biler', url: '/brugte-biler', sort_order: 1 },
    {
      label: 'Autoværksted',
      url: '#',
      sort_order: 2,
      children: [
        { label: 'Serviceeftersyn', url: '/serviceeftersyn' },
        { label: 'Dækhotel', url: '/daekhotel' },
        { label: 'Dækskift', url: '/daekskift' },
        { label: 'Elbil service', url: '/elbil-service' },
        { label: 'Montering af vinterdæk', url: '/vinterdaek' },
      ],
    },
    { label: 'Finansiering/Motor forsikring', url: '/finansering', sort_order: 3 },
    {
      label: 'Beregn byttepris',
      url: 'https://lg.indicata.com/#/?dealerId=156f3c15-a501-4045-bf19-5598ec416fd9',
      is_external: true,
      sort_order: 4,
    },
    { label: 'Om os', url: '/om-os', sort_order: 5 },
    { label: 'Kontakt', url: '/kontakt', sort_order: 6 },
  ]
}

export async function fetchGalleries() {
  try {
    const res = await fetch('/_api/public/content/galleri')
    if (res.ok) {
      const items = await res.json()
      if (Array.isArray(items) && items.length > 0) {
        return items
          .map((i) => i.data || i)
          .sort((a, b) => (Number(a.sort_order) || 0) - (Number(b.sort_order) || 0))
      }
    }
  } catch (err) {
    console.warn('Could not fetch galleri from CMS:', err)
  }
  return []
}

export async function fetchCmsPage(path) {
  try {
    const res = await fetch('/_api/public/content/pages')
    if (res.ok) {
      const items = await res.json()
      if (Array.isArray(items)) {
        const found = items.find((i) => {
          const d = i.data || i
          return d.url_path === path
        })
        if (found) return found.data || found
      }
    }
  } catch (err) {
    console.warn(`Could not fetch page ${path} from CMS:`, err)
  }
  return null
}
